export default __webpack_public_path__ + "static/media/learn_illus_hexagonal.6df1368f.png";